export const VIANDA_COUPON_MESSAGES = {
	discount: 'No se puede acumular cupón con planes de viandas que ya tienen descuento.',
	general:
		'Los cupones generales no aplican a carritos con viandas. Solo se permiten cupones con alcance "Solo viandas de 20 días".',
	only20Days: 'Este cupón solo aplica a planes de viandas de 20 días.',
};

export const CUPON_SCOPE = {
	general: 'GENERAL',
	only20Days: 'SOLO_VIANDAS_20_DIAS',
};

const getCantidadDias = (item) => Number(item?.cantidadDias ?? item?.cantidad_dias ?? 0);

const hasDescuentoPropio = (item) => {
	const descuentoId = item?.descuentoId ?? item?.descuento_id ?? null;
	return Number(descuentoId) > 0;
};

const getViandas = (cartItems = []) => cartItems.filter((item) => item?.tipo === 'vianda');

export const getViandaCouponUniversalBlockReason = (cartItems = []) => {
	const viandas = getViandas(cartItems);

	if (viandas.length === 0) {
		return null;
	}

	if (viandas.some((item) => hasDescuentoPropio(item))) {
		return VIANDA_COUPON_MESSAGES.discount;
	}

	return null;
};

export const getViandaCouponBlockReason = (cartItems = [], couponScope = CUPON_SCOPE.general) => {
	const viandas = getViandas(cartItems);

	if (viandas.length === 0) {
		return null;
	}

	const universalBlockReason = getViandaCouponUniversalBlockReason(viandas);
	if (universalBlockReason) {
		return universalBlockReason;
	}

	if (couponScope === CUPON_SCOPE.general) {
		return VIANDA_COUPON_MESSAGES.general;
	}

	if (couponScope === CUPON_SCOPE.only20Days && viandas.some((item) => getCantidadDias(item) !== 20)) {
		return VIANDA_COUPON_MESSAGES.only20Days;
	}

	return null;
};
